import React, { useState, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.css";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import { useSelector, useDispatch } from "react-redux";
import * as constantMessages from "../../constants/constatntMessages";
import { editAgenda } from "../../redux/actions/minuteActions/MinuteAction";
import {
  cleanInput,
  getStringLengthAfterHTMLParse,
  encryptWithAES,
  decryptWithAES,
} from "../../helpers/commonHelpers";

import ReactQuill from "../../../node_modules/react-quill/lib/index";
import LoaderButton from "../Common/LoaderButton";
import SmallLoaderButton from "../Common/SmallLoaderButton";

const EditAgendaModal = (props) => {
  const modules = {
    toolbar: [
      [{ header: [1, 2, 3, 4, 5, 6, false] }],
      ["bold", "italic", "underline"],
      [{ list: "ordered" }, { list: "bullet" }],
    ],
  };

  const formats = ["header", "bold", "italic", "underline", "list", "bullet"];
  const regularExpressionForAgendaTitle =
    /^[0-9a-zA-Z .,:\n;%@&#!$^*+=`~()/_'"\\\-?|{}\[\]]+$/;

  const dispatch = useDispatch();
  const accessToken = localStorage.getItem("accessToken");
  const minuteData = useSelector((state) => state.minute);
  const meetingDatas = useSelector((state) => state.meeting);

  const { agendaData, meetingData } = props;

  const [errors, setErrors] = useState({});
  const [formData, setFormData] = useState({
    title: "",
    // topic: "",
    timeLine: 1,
  });
  const minuteDatas = useSelector((state) => state.minute);

  const [maxAllowedMinutes, setMaxAllowedMinutes] = useState(0);
  const [remainingTimeLine, setRemainingTimeLine] = useState(0);
  const [remainingMinutes, setRemainingMinutes] = useState(0);
  const [topic, setTopic] = useState(null);
  useEffect(() => {
    setFormData({
      ...formData,
      title: agendaData?.title,
      timeLine: agendaData?.timeLine,
    });
    if (props.IsEditAgendaModal) {
      setTopic(decryptWithAES(agendaData?.topic));
      setFormData({
        ...formData,
        title: agendaData?.title,
        timeLine: agendaData?.timeLine,
      });
    } else {
      setTopic(null);
      setFormData({
        title: "",
        timeLine: 1,
      });
    }

    if (minuteData.isSuccess) {
      props.setIsEditAgendaModal(false);
    }
  }, [props.IsEditAgendaModal, minuteData.isSuccess]);

  const handleSubmit = () => {
    const newErrors = validateForm(formData);
    setErrors(newErrors);

    if (Object.keys(newErrors).length === 0) {
      const payload = {
        title: cleanInput(formData.title),
        topic: encryptWithAES(topic),
        organizationId: agendaData.organizationId,
        meetingId: agendaData.meetingId,
        timeLine: formData.timeLine === "" ? 0 : formData.timeLine,
      };

      dispatch(
        editAgenda(payload, agendaData._id, accessToken, props?.fromViewMeeting)
      );
    }
  };

  const validateAgendaTitle = () => {
    const errors = {};
    if (!formData?.title?.trim()) {
      errors.title = constantMessages.titleRequired;
    } else if (
      formData?.title?.trim().length < 5 ||
      formData?.title?.trim().length > 100
    ) {
      errors.title = constantMessages.stringLengthError;
    } else if (
      !regularExpressionForAgendaTitle.test(cleanInput(formData.title))
    ) {
      errors.title = constantMessages.htmlTagsNotAllowed;
    }

    setErrors(errors);
  };

  const validateAgendaTime = () => {
    const errors = {};

    if (remainingMinutes === 0) {
      setErrors({});
      return;
    }
    if (formData.timeLine > remainingMinutes || formData.timeLine < 1) {
      errors.timeLine = constantMessages.invalidTime;
    }
    setErrors(errors);
  };

  const handleChange = (e, uid) => {
    setErrors({});

    const { name, value } = e.target;

    setFormData({
      ...formData,

      [name]: value,
    });
  };

  const validateForm = () => {
    //
    const errors = {};

    if (!formData?.title?.trim()) {
      errors.title = constantMessages.titleRequired;
    } else if (
      formData.title?.trim().length < 5 ||
      formData.title?.trim().length > 100
    ) {
      errors.title = constantMessages.stringLengthError;
    } else if (
      !regularExpressionForAgendaTitle.test(cleanInput(formData.title))
    ) {
      errors.title = constantMessages.htmlTagsNotAllowed;
    }

    return errors;
  };

  const validateAgendaTopic = () => {
    const errors = {};

    setErrors(errors);
  };

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      event.preventDefault();
    }
    // Block the 'e', 'E', '+', and '-' keys
    if (["e", "E", "+", "-"].includes(event.key)) {
      event.preventDefault();
    }
  };
  const handleValue = (value) => {
    setTopic(value);
  };

  const resetModal = () => {
    // setTopic(agendaData?.topic);
    setTopic(decryptWithAES(agendaData?.topic));
    setFormData({
      ...formData,
      title: agendaData?.title,
      timeLine: agendaData?.timeLine,
    });
    setErrors({});
  };

  function getRemainingMinutes(fromTimeStr, toTimeStr, actualDate) {
    if (!fromTimeStr || !toTimeStr || !actualDate) return 0;
    const date = actualDate.slice(0, 10); // format YYYY-MM-DD
    const fromTime = new Date(`${date}T${fromTimeStr}:00Z`);
    const toTime = new Date(`${date}T${toTimeStr}:00Z`);
    const diffInMilliseconds = toTime - fromTime;
    return Math.floor(diffInMilliseconds / 60000);
  }

  useEffect(() => {
    const meeting = meetingData?.singleMeetingDetails;

    if (
      !meeting?.actualFromTime ||
      !meeting?.actualToTime ||
      !meeting?.actualDate
    ) {
      return;
    }

    const totalMinutes = getRemainingMinutes(
      meeting.actualFromTime,
      meeting.actualToTime,
      meeting.actualDate
    );

    // If editing, exclude current agenda's original time
    let usedMinutes = 0;

    if (agendaData?._id) {
      // editing mode: exclude current agenda's original timeLine
      usedMinutes = meeting?.agendasDetail?.reduce((sum, agenda) => {
        if (agenda._id === agendaData._id) return sum; // exclude
        return sum + parseInt(agenda?.timeLine || 0);
      }, 0);
    } else {
      // create mode
      usedMinutes = meeting?.agendasDetail?.reduce(
        (sum, agenda) => sum + parseInt(agenda?.timeLine || 0),
        0
      );
    }

    const remaining = totalMinutes - usedMinutes;

    setMaxAllowedMinutes(remaining);
    setRemainingMinutes(Math.max(0, Number(remaining)));

    if (props?.fromMinute) {
      // setTopic(agendaData?.topic);
      setTopic(decryptWithAES(agendaData?.topic));
      setFormData({
        ...formData,
        title: agendaData?.title,
        timeLine: parseInt(agendaData?.timeLine),
      });
      setRemainingMinutes(Math.max(0, Number(remaining)));
    }
  }, [meetingData, agendaData]);

  const closeModal = () => {
    setTopic(null);
    setFormData({
      title: "",
      timeLine: 1,
    });
    setErrors({});
    props.setIsEditAgendaModal(false);
  };

  return (
    <>
      <Modal
        size="lg"
        show={props.IsEditAgendaModal}
        onHide={() => closeModal()}
        backdrop="static"
      >
        <Modal.Dialog>
          <div className="modal-header attendees-modal">
            <div>
              <h4 className="modal-title">Edit Agenda</h4>
            </div>
            <div>
              <button
                type="button"
                className="btn-close"
                aria-label="Close"
                onClick={() => closeModal()}
              ></button>
            </div>
          </div>

          <Modal.Body className="attendees-popup modal-margin">
            <div className="open-div">
              <div className="minutes-box no-border">
                <div className="form-group">
                  <div className="mb-2">
                    <div className="row">
                      <div className="col-md-12">
                        <label className="mb-1">
                          Agenda Title <span className="star-mark">*</span>
                        </label>
                      </div>
                      <div className="col-md-12">
                        <input
                          type="text"
                          placeholder="Enter agenda title"
                          name="title"
                          value={formData.title}
                          onChange={handleChange}
                          onBlur={validateAgendaTitle}
                          autoComplete="off"
                        />

                        {errors.title ? (
                          <span className="error-message">{errors.title}</span>
                        ) : null}
                      </div>
                    </div>
                  </div>
                </div>

                <div className="form-group">
                  <div className="row">
                    <div className="col-md-12">
                      <label className="mb-1">
                        What are the topic to discuss ?
                      </label>
                    </div>
                    <div className="col-md-12">
                      <ReactQuill
                        theme="snow"
                        placeholder="Please add topic"
                        onChange={handleValue}
                        value={topic}
                        onBlur={validateAgendaTopic}
                        modules={modules}
                        formats={formats}
                        style={{ background: "white" }}
                        className="custom-quill-editor"
                      />

                      <p className="success-message">
                        {getStringLengthAfterHTMLParse(topic)} Characters
                      </p>
                      {errors.topic && (
                        <span className="error-message">{errors.topic}</span>
                      )}
                    </div>
                  </div>
                </div>

                <div className="form-group m-0">
                  <div className="row">
                    <div className="col-md-12">
                      <label className="mb-1">
                        How long will this agenda item take to discuss?
                      </label>
                    </div>

                    <div className="col-md-12">
                      <div className="time-taken bg-white">
                        <input
                          name="timeLine"
                          value={formData.timeLine}
                          onChange={(e) => {
                            const input = e.target.value;
                            const isValidNumber = /^[1-9][0-9]*$/.test(input);
                            const value = parseInt(input);
                            if (
                              input === "" ||
                              (isValidNumber && value <= remainingMinutes)
                            ) {
                              handleChange(e);
                            }
                          }}
                          onBlur={validateAgendaTime}
                          required
                          onKeyDown={handleKeyDown}
                          type="number"
                          autoComplete="off"
                          max={maxAllowedMinutes}
                        />
                        <div className="minute_box">mins</div>
                      </div>

                      {/* Error message if any */}
                      {errors.timeLine && (
                        <span className="error-message">{errors.timeLine}</span>
                      )}

                      {/* Remaining minutes status */}
                      <div
                        className="min-left-text"
                        style={{
                          marginTop: "5px",
                          color:
                            formData.timeLine > remainingMinutes ||
                              remainingMinutes - formData.timeLine === 0
                              ? "red"
                              : "#008000",
                        }}
                      >
                        {formData.timeLine > remainingMinutes
                          ? `${remainingMinutes} minute(s)`
                          : `${Math.max(
                            remainingMinutes - Number(formData.timeLine),
                            0
                          )} minute(s) left`}
                      </div>
                    </div>

                    {/* Alert when no minutes left */}
                    {remainingMinutes - formData.timeLine === 0 && (
                      <div className="col-12 mt-2">
                        <div className="alert alert-warning">
                          <strong>Note:</strong> Please increase Meeting
                          Duration (e.g., by 1 or 2 hours) to add more agenda
                          items.
                        </div>
                      </div>
                    )}
                  </div>

                  <div className="mt-3 plus pointer"></div>
                </div>
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant=""
              type="button"
              onClick={() => resetModal()}
              className="add-minutes Mom-btn"
            >
              <p>Reset</p>
            </Button>

            {!minuteDatas.loading ? (
              <Button
                variant=""
                onClick={handleSubmit}
                className="create-meeting-button Mom-btn"
              >
                <p>Update</p>
              </Button>
            ) : (
              <div className="meeting-page " style={{ textAlign: "center" }}>
                <SmallLoaderButton />
              </div>
            )}
          </Modal.Footer>
        </Modal.Dialog>
      </Modal>
    </>
  );
};

export default EditAgendaModal;
